import React from 'react';

function QuestionInputNumber(props: {
    placeholder: string;
    value: string;
    setValue: (v: string) => void;
    onChange: (e: React.ChangeEvent) => void;
}): JSX.Element {
    const { placeholder, onChange } = props; 

    // 이메일 한글 입력 막기
    let { value } = props;
    value = value.replace( /[ㄱ-ㅎ|ㅏ-ㅣ|가-힣]/g, '');

    return <input type="text" id="textField_text" value={value} onChange={onChange} placeholder={placeholder} />;
}

export default QuestionInputNumber;